var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"card",staticClass:"glassy-card",class:[_vm.align, { visible: _vm.isVisible }],attrs:{"href":_vm.link}},[_c('div',{staticClass:"card-images"},[_c('img',{attrs:{"src":_vm.image,"alt":"card image"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }